export const environment = {
  production: true,
  // apilocalUrl: '/assets/data/',
  // apiUrl: 'https://ccpsapi.clikpaygroup.com/', //live

  apilocalUrl: '/assets/data/',
  // apiUrl: 'https://stagingccpsapi.clikpaygroup.com/', //stagging
  // apiUrl: 'http://ccps-frontend.local/', //local
  apiUrl: 'https://demo.api.pups.gouv.ga/', //Gabon demo
  enc_token: "58120C891223112818424CF0CEF8CA3569D340F77CCD25D3CD90AC57686535E9",
  encryption_mode: true,
  firebaseConfig: {
    apiKey: "AIzaSyBq1CjJitzt3AeBH4EpXsVOmO4tvdC1lpQ",
    authDomain: "ccps-frontend.firebaseapp.com",
    projectId: "ccps-frontend",
    storageBucket: "ccps-frontend.appspot.com",
    messagingSenderId: "488101046303",
    appId: "1:488101046303:web:50d8f858aa85bb169e0d2a",
    measurementId: "G-5HT22RYRLF"
  }
};
